import { SelectField } from '@flos/react-ui';
import { type AttributeChangeProps } from '../../../types';
import { useRecoilValue, useSetRecoilState } from 'recoil';
import { isOpcDataFilledAtom } from '../../../../../recoil/atoms/isOpcDataFilledAtom';
import { getPrimaryHeatingOptionsSelector } from '../../../../../recoil/selectors/getPrimaryHeatingOptionsSelector';
import type { PrimaryHeating } from 'gw-edge-client/dist/types/dto/pc/typekey';
import { callMeVariantOpcAtom } from '../../../../../recoil/atoms/callMeVariantOpcAtom';
import { useHippoText } from '../../../../../hooks/useHippoText';
import { getOPCCoverableAttributeSelector } from '../../../../../recoil/selectors/getOPCCoverableAttributeSelector';

const HousePrimaryHeatingChange = ({
    updateCoverableAttribute
}: AttributeChangeProps): React.JSX.Element => {
    const getHippoText = useHippoText();
    const setIsOpcDataFilled = useSetRecoilState(isOpcDataFilledAtom);
    const currentOPCAttribute = useRecoilValue(getOPCCoverableAttributeSelector)?.prhHouse
        ?.primaryHeating;
    const heatingOptions = useRecoilValue(getPrimaryHeatingOptionsSelector);
    const setCallMeVariant = useSetRecoilState(callMeVariantOpcAtom);

    const handleChange = (event: React.ChangeEvent<HTMLSelectElement>): void => {
        const selectedIndex = event.target.selectedIndex;
        const { value } = event.target.options[selectedIndex];
        if (value === 'StrawHeating' || value === 'OtherHeating') {
            setCallMeVariant('prhPrimaryHeating');
            setIsOpcDataFilled(false);
        } else {
            updateCoverableAttribute({ primaryHeating: value as PrimaryHeating });
            setIsOpcDataFilled(true);
        }
    };
    return (
        <div>
            <h6>{getHippoText('DSS-EDIT-PRIMARY-HEATING-QUESTION')}</h6>
            <SelectField
                data-testid="select-option"
                label={'DSS-OPC-INPUT-LABEL'}
                options={heatingOptions}
                onChange={handleChange}
                defaultValue={currentOPCAttribute}
            />
        </div>
    );
};

export default HousePrimaryHeatingChange;
